import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicyPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
      {/* Header */}
      <div className="sticky top-0 z-30 bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-b border-gray-200/60 dark:border-gray-700/40">
        <div className="max-w-[800px] mx-auto flex items-center gap-3 px-4 py-3">
          <button
            onClick={onBack}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-100/80 dark:bg-gray-800/60 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors border-none cursor-pointer"
          >
            <ArrowLeft size={18} />
          </button>
          <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Политика конфиденциальности
          </h1>
        </div>
      </div>

      {/* Content */}
      <article className="max-w-[800px] mx-auto px-4 py-6">
        <div className="prose prose-sm dark:prose-invert max-w-none text-gray-700 dark:text-gray-300 leading-relaxed space-y-6">

          <p className="text-xs text-gray-400 dark:text-gray-500">
            Дата вступления в силу: 1 марта 2026 г. Версия: 1.0
          </p>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              1. Общие положения
            </h2>
            <p className="text-sm">
              Настоящая Политика конфиденциальности определяет порядок обработки и защиты
              персональных данных пользователей сервиса «Путь рыбы» (далее — Сервис),
              доступного по адресу <span className="text-sky-500">pathoffish.ru</span> и
              через приложения в мессенджерах.
            </p>
            <p className="text-sm">
              Оператор персональных данных — администрация Сервиса (далее — Оператор).
              Обработка персональных данных осуществляется в соответствии с Федеральным
              законом от 27.07.2006 № 152-ФЗ «О персональных данных».
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              2. Какие данные мы собираем
            </h2>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li><strong>Данные авторизации:</strong> имя, фамилия, имя пользователя и идентификатор из Telegram, ВКонтакте, Яндекс ID или email-адрес</li>
              <li><strong>Контактные данные:</strong> номер телефона, адрес доставки (район, подъезд, этаж, квартира)</li>
              <li><strong>Данные заказов:</strong> состав, суммы, история покупок, бонусный баланс</li>
              <li><strong>Технические данные:</strong> IP-адрес, User-Agent, тип устройства и браузера</li>
              <li><strong>Файлы cookie:</strong> используются для корректной работы сайта и запоминания ваших предпочтений</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              3. Цели обработки
            </h2>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Оформление и доставка заказов</li>
              <li>Идентификация пользователя и обеспечение безопасности аккаунта</li>
              <li>Начисление и списание бонусов</li>
              <li>Связь с пользователем (уведомления о заказах, статусе доставки)</li>
              <li>Улучшение работы Сервиса и аналитика</li>
              <li>Выполнение требований законодательства РФ (в т.ч. налоговый учёт)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              4. Правовые основания
            </h2>
            <p className="text-sm">
              Обработка персональных данных осуществляется на основании:
            </p>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Согласия пользователя (ст. 9 ФЗ-152) — при регистрации и оформлении заказа</li>
              <li>Исполнения договора — для обработки и доставки заказов</li>
              <li>Законных интересов оператора — для обеспечения безопасности и аналитики</li>
              <li>Требований законодательства — хранение данных о заказах в течение 5 лет (НК РФ)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              5. Хранение и защита данных
            </h2>
            <p className="text-sm">
              Персональные данные хранятся на серверах, расположенных на территории
              Российской Федерации, в соответствии с требованиями ч. 5 ст. 18 ФЗ-152.
            </p>
            <p className="text-sm">
              Для защиты данных применяются:
            </p>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Шифрование персональных данных (AES-256)</li>
              <li>Защищённые соединения (HTTPS/TLS)</li>
              <li>Разграничение доступа и аутентификация по токенам</li>
              <li>Регулярное резервное копирование</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              6. Файлы cookie
            </h2>
            <p className="text-sm">
              Сервис использует файлы cookie для:
            </p>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Поддержания сессии авторизации</li>
              <li>Запоминания пользовательских предпочтений (тема оформления)</li>
              <li>Обеспечения корректной работы корзины</li>
            </ul>
            <p className="text-sm">
              Вы можете отключить файлы cookie в настройках браузера. В этом случае
              некоторые функции Сервиса могут работать ограниченно.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              7. Передача данных третьим лицам
            </h2>
            <p className="text-sm">
              Персональные данные не продаются и не передаются третьим лицам, за исключением:
            </p>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Служб доставки — для выполнения заказа (имя, телефон, адрес)</li>
              <li>Платёжных систем — для обработки оплаты (в зашифрованном виде)</li>
              <li>По требованию законодательства РФ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              8. Ваши права
            </h2>
            <p className="text-sm">
              В соответствии с ФЗ-152 вы имеете право:
            </p>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Получить информацию об обработке ваших персональных данных</li>
              <li>Потребовать уточнения, блокирования или уничтожения данных</li>
              <li>Отозвать согласие на обработку персональных данных</li>
              <li>Запросить удаление аккаунта и всех связанных данных</li>
            </ul>
            <p className="text-sm">
              Для реализации своих прав используйте функцию «Удалить данные» в подвале
              сайта или обратитесь на{' '}
              <a href="mailto:pathoffish@yandex.ru" className="text-sky-500 hover:underline">
                pathoffish@yandex.ru
              </a>.
              Срок обработки запроса — до 30 дней.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              9. Сроки хранения
            </h2>
            <ul className="text-sm space-y-1.5 list-disc pl-5">
              <li>Данные аккаунта — до момента удаления аккаунта пользователем</li>
              <li>Данные заказов — 5 лет с момента заказа (требование НК РФ)</li>
              <li>Логи согласий — бессрочно (аудит ФЗ-152)</li>
              <li>Технические логи — до 1 года</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              10. Изменения политики
            </h2>
            <p className="text-sm">
              Оператор вправе вносить изменения в настоящую Политику. Актуальная версия
              всегда доступна на данной странице. Продолжая пользоваться Сервисом после
              изменений, вы принимаете обновлённую Политику.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 mb-2">
              11. Контакты
            </h2>
            <p className="text-sm">
              По вопросам обработки персональных данных:{' '}
              <a href="mailto:pathoffish@yandex.ru" className="text-sky-500 hover:underline">
                pathoffish@yandex.ru
              </a>
            </p>
          </section>

        </div>
      </article>
    </div>
  );
};

export default React.memo(PrivacyPolicyPage);
